// urls to external services (e.g. clearbit company autosuggest, etc.)
export const serviceUrls = Object.freeze({
  CLEARBIT_COMPANY_URL: 'https://autocomplete.clearbit.com/v1/companies/suggest',
  GOOGLE_FAVICON_URL: '//www.google.com/s2/favicons?domain='
});
